import {set3dsPbkdf2Provider} from '@resurs-internal/rb-app-api';

/**
 * Registers the browser-native WebCrypto provider for the Mastercard 3DS
 * static-password PBKDF2 hash, replacing the package's pure-JS node-forge
 * default (which is slow in a browser). Byte-identical to rb-app's
 * `src/services/pbkdf2.web.ts`.
 *
 * SECURITY: only the derived key is produced here — the plaintext is supplied
 * by the shared hook and is never logged.
 */
export const webCryptoPbkdf2Sha512 = async ({
  password,
  saltHex,
  iterations,
  keyLengthBytes,
}: {
  password: string;
  saltHex: string;
  iterations: number;
  keyLengthBytes: number;
}): Promise<string> => {
  const salt = Uint8Array.from(
    saltHex.match(/../g)?.map((byte) => parseInt(byte, 16)) ?? [],
  );
  const key = await crypto.subtle.importKey(
    'raw',
    new TextEncoder().encode(password),
    'PBKDF2',
    false,
    ['deriveBits'],
  );
  const bits = await crypto.subtle.deriveBits(
    {name: 'PBKDF2', hash: 'SHA-512', salt, iterations},
    key,
    keyLengthBytes * 8,
  );
  return [...new Uint8Array(bits)]
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');
};

set3dsPbkdf2Provider(webCryptoPbkdf2Sha512);
